import React, { useEffect, useState } from 'react';
import { Box, Dialog, SxProps, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { Input } from 'components/Inputs';
import { useInputModal } from 'services/modals/hooks';
import { useRecoilValue } from 'recoil';
import { inputModalAtom } from 'services/modals/atoms';

const buttonsContainer: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 2
};

export const InputConfirmationModal = () => {
  const [inputValue, setInputValue] = useState('');
  const { hideModal } = useInputModal();
  const {
    isOpen,
    title,
    inputLabel,
    onConfirmClick,
    initialValue,
    inputSubLabel
  } = useRecoilValue(inputModalAtom);

  useEffect(() => {
    setInputValue(initialValue ?? '');
  }, [initialValue]);

  return (
    <Dialog open={isOpen} onClose={hideModal}>
      <Box sx={{ p: 2, minWidth: 300 }}>
        <Typography fontWeight="bold">{title}</Typography>

        <Box my={2}>
          <Input
            label={inputLabel}
            subLabel={inputSubLabel}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Box>
        <Box sx={buttonsContainer}>
          <Button
            onClick={() => {
              onConfirmClick(inputValue);
              hideModal();
            }}
            disabled={inputValue.length < 3}
            variant="primary"
            fullWidth
          >
            Save
          </Button>
          <Button onClick={hideModal} fullWidth>
            Cancel
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
